<template>
  <div class="content">
    <div class="page">
      <h2>可视化大屏</h2>
      <div class="message">
        平台可根据街道、社区、物业不同的职能范围进行首页定制，满足不同层次的管理需要，建立集政府监督、预警联动、智能分析、物业管理、便民服务等于一体的智慧社区业务管理平台，打造小事不出网格，大事不出村社的基层治理新样板。
      </div>
      <img
        src="../../../../assets/image/residentialQuartersImg/u946.png"
        alt=""
      />
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "",
  data() {
    return {};
  },

  methods: {},
};
</script>
 
<style scoped lang="scss">
.content {
  padding: 0 16%;
  box-sizing: border-box;
  min-height: calc(100vh - 387px);
  width: 100%;
  margin-bottom: 50px;
  .page {
    margin-top: 50px;
    width: 100%;
    height: 720px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px;
    // position: relative;
    text-align: center;
    > h2 {
      text-align-last: left;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 30px 0;
    }
    .message {
      text-align-last: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6b6b6b;
      margin-bottom: 50px;
    }
  }
}
</style>